import { createContext } from 'react';

import { type CartPreview } from '../../shared/types';

const CartContext = createContext<CartPreview | null>(null);

export { CartContext };
